import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const UnitPrice = ({ amount , currencyCode , className , fixedDecimals , isCentAmount =false ,  })=>{
    const { getFormattedLabel , locale  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames('unit-price', className)
    }, getFormattedLabel('common.pricePerUnit', {
        labelData: {
            pricePerUnit: formatPrice({
                locale,
                value: amount,
                currency: currencyCode,
                fixedDecimals,
                isCentAmount
            })
        }
    }));
};

export { UnitPrice };
//# sourceMappingURL=UnitPrice.js.map
